export default {
    nav: '反馈',
    dialog: {
        titleList: '我的反馈',
        titleNew: '新建反馈',
        titleDetail: '反馈详情',
    },
    list: {
        new: '新建反馈',
        loading: '加载中...',
        empty: '还没有反馈记录，您的每一条意见都会让产品变得更好',
        delete: '删除',
    },
    status: {
        pending: '待处理',
        processing: '处理中',
        resolved: '已解决',
        closed: '已关闭',
    },
    category: {
        bug: '缺陷',
        suggestion: '建议',
        feature_request: '功能请求',
        other: '其它',
    },
    form: {
        intro: '您的反馈对我们非常重要，每一条都会被看见',
        titleLabel: '标题',
        titlePlaceholder: '请简要描述问题或建议',
        categoryLabel: '类型',
        contentLabel: '描述',
        contentPlaceholder: '请详细描述您遇到的问题或建议，越详细越好...',
        cancel: '取消',
        submit: '提交反馈',
        submitting: '提交中...',
        bold: '加粗',
        italic: '斜体',
        strikethrough: '删除线',
        bulletList: '无序列表',
        orderedList: '有序列表',
        blockquote: '引用',
    },
    success: {
        title: '感谢您的反馈！',
        message: '我们已经收到您的反馈，团队会认真阅读并尽快跟进。您的每一条意见都在帮助我们做得更好。',
        viewList: '查看我的反馈',
    },
    detail: {
        back: '返回列表',
        replyPlaceholder: '追加回复...',
        send: '发送',
        sending: '发送中',
        uploadImage: '上传图片',
    },
};

